import React from 'react';
import { TooltipProps, TooltipPropsWithTitle } from 'antd/lib/tooltip';
import { Tooltip as TooltipExt } from 'antd';
import { defaultProps } from '@config/antd.config';
import TooltipDate from './TooltipDate';

type TExtendTooltipProps = TooltipProps & TooltipPropsWithTitle;

export const Tooltip = (props: TExtendTooltipProps) => {
  return (
    <TooltipExt {...defaultProps.tooltipProps} {...props}>
      {props.children}
    </TooltipExt>
  );
};

Tooltip.Date = TooltipDate;
